import React from "react";
import styles from "./styles.module.scss";

type LoaderScreenProps = {
  opacity?: boolean;
};

const LoaderScreen = ({ opacity }: LoaderScreenProps) => {
  return (
    <div className={styles["loader-wrapper"]}>
      <div
        className={`${styles.background} ${opacity ? styles["with-opacity"] : ""}`}
      ></div>
      <div className={styles.spinner}>
        <img src="/inst/img/loader-new.gif" alt="loading" />
      </div>
    </div>
  );
};

export default LoaderScreen;
